import { render, staticRenderFns } from "./ClassroomDetailTabGlobalPartner.vue?vue&type=template&id=4220d52b&scoped=true"
import script from "./ClassroomDetailTabGlobalPartner.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabGlobalPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4220d52b",
  null
  
)

export default component.exports